import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { clearSpaceContentCountsAction } from '../../actions/spaces/ContentCountsActions';
import { showContentTypes } from '../../actions/spaces/ContentExplorerFilterActions';
import { requestSpaceContents } from '../../actions/spaces/RequestSpaceContentsActions';
import {
  selectCurrentlyApplicableContentTypes,
  selectDefaultContentTypeFilterValues,
} from '../../selectors/ContentFilterSelectors';
import { siteUrlsSelector } from '../../selectors/SiteUrlsSelectors';
import { AppState } from '../../state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../utils/ConnectUtils';
import {
  FavoritesSpaceDispatchProps,
  FavoritesSpaceOwnProps,
  FavoritesSpaceStateProps,
  FavoritesSpace,
} from './FavoritesSpace';

const mapStateToProps: MapStateToProps<FavoritesSpaceStateProps> = (state: AppState) => ({
  contentTypeFilterValues: selectCurrentlyApplicableContentTypes(state),
  defaultContentTypeFilterValues: selectDefaultContentTypeFilterValues(state),
  urls: siteUrlsSelector(state)
});

const mapDispatchToProps: MapDispatchToProps<FavoritesSpaceDispatchProps> = (dispatch) => bindActionCreators({
  filterSelected: showContentTypes,
  requestSpaceContents,
  clearContentCounts: clearSpaceContentCountsAction,
}, dispatch);

export const ConnectedFavoritesSpace: React.ComponentClass<FavoritesSpaceOwnProps> =
  connect(mapStateToProps, mapDispatchToProps)(FavoritesSpace);
